import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { messageService } from '../messages/message.module';

@Injectable({ providedIn: 'root' })
export class ReportExtractService {
  url = '/api/DataExtract/reportExtract';
  constructor(private http: HttpClient, protected router: Router) {}

  generateExtract(reportObject): Observable<any> {
    const filterDataset = reportObject.dataset;
    const filterProcess = reportObject.process || 'X';
    const filterDateFrom = reportObject.dateFrom;
    const filterDateTo = reportObject.dateTo;
    const filterIncludeArchived = reportObject.includeArchived || 'X';

    //const url = `${this.url}/${reportObject.dataset}/${reportObject.process}/${reportObject.dateFrom}/${reportObject.dateTo}`;
    let url = `api/DataExtract/reportExtract/${filterDataset}/${filterIncludeArchived}`;
    if (filterDateFrom && filterDateTo) {
      url = url + `/${filterDateFrom}/${filterDateTo}`;
    }
    if (filterProcess) {
      url = url + `/${filterProcess}`;
    }
    console.log(url);    
    return this.http
      .get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          timeout: '28800000',
        }),
      })
      .pipe(
        map(
          (result) => {
            return result;
          },
          (error) => {
            console.log(error);
            messageService.error(
              'Something has occured when extracting data. Please try again'
            );
          }
        )
      );
  }
}
